import 'css-chunksrc/client/pages/projectPage/budgetPage/expensesTable/styles.scss';export default {
  "projectExpenses": "_projectExpenses_al08x_1",
  "header": "_header_al08x_5",
  "cell": "_cell_al08x_10",
  "bigCell": "_bigCell_al08x_22",
  "mediumCell": "_mediumCell_al08x_26",
  "smallCell": "_smallCell_al08x_30",
  "row": "_row_al08x_35",
  "rowCell": "_rowCell_al08x_40",
  "bold": "_bold_al08x_53",
  "icon": "_icon_al08x_57"
};